import React from 'react';
import { checkTextTranslation, translate } from '../../utils/useful'

export default class HubNotFound extends React.Component {

    state = {
    }

    render() {
        return (
            <section className="w-100 text-center pt-5 flexcc">
                <div>
                    <div style={{ borderRadius: 8, padding: '50px 50px' }}>
                        <img src="/images/man.svg" height="70px" />
                        <h1 className="text-semibig mb-1 mt-1">{translate('Hub Not found').toUpperCase()}</h1>
                        <p className="text-small" style={{ color: '#789' }}>{translate('The-Hub-Does-not-exist')}</p>
                        <p className="text-small" style={{ color: '#789' }}>{translate('Please double check the id')}</p>

                    </div>
                </div>
            </section>

        )
    }
}